export default __webpack_public_path__ + "static/animated svg-3e2657c5cad9c09b8c2db63dd0b2f771.svg";